import { render, staticRenderFns } from "./EditTemplateRefComponent.vue?vue&type=template&id=3ebef348&scoped=true&"
import script from "./EditTemplateRefComponent.vue?vue&type=script&lang=js&"
export * from "./EditTemplateRefComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplateRefComponent.vue?vue&type=style&index=0&id=3ebef348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebef348",
  null
  
)

export default component.exports